import {useState, useEffect} from 'react';
import {ReactComponent as LikeIcon} from '../../../images/like-icon.svg';
import {ReactComponent as DislikeIcon} from '../../../images/dislike-icon.svg';
import * as Styled from './FeedbackStyles';
import CommentBlock from "./CommentBlock";
import {useDispatch} from "react-redux";
import {feedbackFetch} from "../../store/searchAction";
import LocalStorage from '../../services/LocalStorage';
import SearchStore from '../../xstores/search';

/*const getFeedbackFromLocal = (feedbacks:any | null, item:any) => {
  let thumb = 0;
  const resId = getLocalId(item);
  const feedback = feedbacks[resId];
  console.log(feedback);
  if (feedback) {
    thumb = feedback.thumbs_up;
  }
  return thumb;
}

const getLocalId = (item:any) => {
  const parts = item.result_id.split(RES_SEPARATOR);
  /!*if (item.pl === 'slack') {
    return parts.slice(0,2).join(RES_SEPARATOR);
  }*!/
  return parts.join(RES_SEPARATOR);
}*/

const Feedback = ({ item, feedback, contained }: any ) => {
  const [thumb, setThumb] = useState(item.feedback ? item.feedback.thumbs_up : 0);
  const [feedbackVisible, setFeedbackVisible] = useState(false);
  const dispatch = useDispatch();
  const hideModal = () => {
    setFeedbackVisible(false);
    submitFeedback('');
  }

  const submitFeedback = (comment:string, th?: number) => {
    const newThumb = th !== undefined ? th : thumb;
    const feedback = {
      result_id: item.result_id,
      comment,
      thumbs_up: newThumb,
      search_id: SearchStore.searchId$.getValue(),
    };
    item.feedback = feedback;
    dispatch(feedbackFetch(feedback));
    const userFeedbacks = LocalStorage.getItem('feedbacks') || {};
    userFeedbacks[item.result_id] = newThumb ? feedback : undefined;
    LocalStorage.setItem('feedbacks', userFeedbacks);
    setFeedbackVisible(false);
  }

  const handleUpClick = () => {
    if (thumb === 1) {
      setThumb(0);
      submitFeedback('', 0);
      return;
    }
    setThumb(1);
    setFeedbackVisible(true);
  }

  const handleDownClick = () => {
    if (thumb === -1) {
      setThumb(0);
      submitFeedback('', 0);
      return;
    }
    setThumb(-1);
    setFeedbackVisible(true);
  }

  useEffect(() => {
    let thumbFeedback = 0;
    if (item.feedback) {
      thumbFeedback = item.feedback.thumbs_up;
    } else {
      const userFeedbacks = LocalStorage.getItem('feedbacks') || {};
      if (item.result_id && userFeedbacks[item.result_id]) {
        thumbFeedback = userFeedbacks[item.result_id].thumbs_up;
      }
    }
    setThumb(thumbFeedback);
  }, [item, feedback]);

  return (
    <Styled.Container>
      <Styled.Container className={contained && 'contained'}>
        <LikeIcon
          className={`feedbackIcon ${thumb === 1 ? 'active' : ''}`}
          onClick={handleUpClick}
        />
      </Styled.Container>
      <Styled.Container className={contained && 'contained'}>
        <DislikeIcon
          className={`feedbackIcon ${thumb === -1 ? 'active' : ''}`}
          onClick={handleDownClick}
        />
      </Styled.Container>

      {feedbackVisible &&
        <CommentBlock
          onDismiss={hideModal}
          onSubmit={submitFeedback}
          isLike={thumb > 0}
        />
      }
    </Styled.Container>
  )
}

export default Feedback;